import React from "react";
import { useNavigate } from "react-router-dom";
import AccessBlockedView from "./common/AccessBlockedView";

export default function NoAccess() {
  const navigate = useNavigate();
  return (
    <div data-testid="no-access">
      <AccessBlockedView
        title="Zugriff verweigert"
        summary="Für diese Seite fehlt Ihrer Rolle die Berechtigung."
        iconClassName="pi pi-lock text-muted"
        actions={[{ label: "Zur Übersicht", onClick: () => navigate("/uebersicht") }]}
      />
    </div>
  );
}
